
import { ReactNode } from 'react';
import styles from './ProductLayout.module.css';

interface ProductLayoutProps {
    gallery: ReactNode;
    info: ReactNode;
}

export const ProductLayout = ({ gallery, info }: ProductLayoutProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.galleryColumn}>
                {gallery}
            </div>
            <div className={styles.infoColumn}>
                {info}
            </div>
        </div>
    );
};
